export class ListMembershipReducerState {
  lists?: any[];
  newList?: boolean;

  constructor(lists?: any[], newList?: boolean) {
    this.lists = lists || [];
    this.newList = newList || false;
  }
}
